<h2 class="sr-only">{{ "StandardSuche" | translate }}</h2>
<form (ngSubmit)="onSubmit()" [meta]="gebaeudeRequest" #form="ngForm">
  @if (gebaeudeRequest) {
    <div>
      <cap-form-row column-classes="col-md-2,col-md-4">
        <cap-form-control column-classes="col-md-2,col-md-4" labelKey="Gemeinde">
          <cap-pol-gemeinde
            (ngModelChange)="gebaeudeRequest && (gebaeudeRequest.polGemeindeId = $event)"
            [hasfocus]="true"
            [ngModel]="gebaeudeRequest && gebaeudeRequest.polGemeindeId"
            [searchMode]="polGemeindeSearchMode"
            class="typeahead-holder"
            name="polGemeindeId"></cap-pol-gemeinde>
          <button (click)="emptyGemeindeSearch()" class="btn btn-white" tabindex="-1" type="button">
            <span class="fas fa-times"></span>
          </button>
        </cap-form-control>
      </cap-form-row>
      <cap-form-row [meta]="gebaeudeRequest.adresseSearchRequest">
        <cap-form-control
          column-classes="col-md-2,input-series col col-md-3"
          invalidKey="NotEnoughChars"
          labelKey="StrasseOderFlurnameHausnummer">
          <input
            (ngModelChange)="
              gebaeudeRequest && gebaeudeRequest.adresseSearchRequest && (gebaeudeRequest.adresseSearchRequest.strasseOderFlurname = $event)
            "
            [ngModel]="gebaeudeRequest && gebaeudeRequest.adresseSearchRequest && gebaeudeRequest.adresseSearchRequest.strasseOderFlurname"
            name="gebaeudeStrasse.adresseSearchRequest.strasseOderFlurname"
            size="20"
            type="text" />
        </cap-form-control>
        <cap-form-control column-classes="col-md-2,input-series col col-md-1 col-sm-2">
          <input
            (ngModelChange)="
              gebaeudeRequest && gebaeudeRequest.adresseSearchRequest && (gebaeudeRequest.adresseSearchRequest.nummer = $event)
            "
            [ngModel]="gebaeudeRequest && gebaeudeRequest.adresseSearchRequest && gebaeudeRequest.adresseSearchRequest.nummer"
            name="nummer"
            size="6"
            type="text" />
        </cap-form-control>
      </cap-form-row>
      <cap-form-row column-classes="col-md-2,col-md-4">
        <cap-form-control column-classes="col-md-2,col-md-4" labelKey="PlzOderOrtschaft">
          <cap-ortschaft-selection
            (ngModelChange)="gebaeudeRequest && (gebaeudeRequest.ortschaftVersionId = $event)"
            [ngModel]="gebaeudeRequest && gebaeudeRequest.ortschaftVersionId"
            class="typeahead-holder"
            name="ortschaftVersionId"></cap-ortschaft-selection>
          <button (click)="emptyOrtschaftSearch()" class="btn btn-white" tabindex="-1" type="button">
            <span class="fas fa-times"></span>
          </button>
        </cap-form-control>
      </cap-form-row>
      <cap-form-row class="mb-4">
        <cap-form-control
          column-classes="col-md-2,col-md-4"
          invalidKey="EingabeMussValideVersicherungsNummerSein"
          labelKey="VersicherungsNr">
          <input
            (ngModelChange)="gebaeudeRequest && (gebaeudeRequest.versicherungsNummer = $event)"
            [ngModel]="gebaeudeRequest && gebaeudeRequest.versicherungsNummer"
            name="versicherungsNummer"
            size="20"
            type="text" />
        </cap-form-control>
      </cap-form-row>
      <div class="row">
        <div class="col-3">
          <h3 class="title-divider">{{"ProjektiertStatus" | translate}}</h3>
          <cap-form-control labelKey="Gebaut">
            <input
              (ngModelChange)="gebaeudeRequest && (gebaeudeRequest.gebaut = $event)"
              [ngModel]="gebaeudeRequest && gebaeudeRequest.gebaut"
              name="gebaut"
              type="checkbox" />
          </cap-form-control>
          <cap-form-control labelKey="Projektiert">
            <input
              (ngModelChange)="gebaeudeRequest && (gebaeudeRequest.projektiert = $event)"
              [ngModel]="gebaeudeRequest && gebaeudeRequest.projektiert"
              name="projektiert"
              type="checkbox" />
          </cap-form-control>
        </div>
        <div class="col-3">
          <h3 class="title-divider">{{"Bauart" | translate}}</h3>
          <cap-form-control labelKey="Oberirdisch">
            <input
              (ngModelChange)="gebaeudeRequest && (gebaeudeRequest.oberirdisch = $event)"
              [ngModel]="gebaeudeRequest && gebaeudeRequest.oberirdisch"
              name="oberirdisch"
              type="checkbox" />
          </cap-form-control>
          <cap-form-control labelKey="Unterirdisch">
            <input
              (ngModelChange)="gebaeudeRequest && (gebaeudeRequest.unterirdisch = $event)"
              [ngModel]="gebaeudeRequest && gebaeudeRequest.unterirdisch"
              name="unterirdisch"
              type="checkbox" />
          </cap-form-control>
        </div>
      </div>
      <div class="p-2" id="actionpane">
        <div class="rechtsbuendig">
          <button (click)="onReset()" class="btn btn-outline-primary btn-actionpane" type="button">{{ "Zurücksetzen" | translate }}</button>
          <button [disabled]="!form.form.valid" class="btn btn-primary btn-actionpane" type="submit">{{ "Suche" | translate }}</button>
        </div>
      </div>
    </div>
  }
</form>
